import { createContext, useContext } from 'react';
import { TimeFilterContextState } from 'modules/iterableGoals/types';
import noop from 'utils/noop';

export const initalTimeFilterContextState = {
  timeParams: {
    startTime: undefined,
    endTime: undefined,
    timeRangeHasData: true,
  },
  updateTimeParams: noop,
};

export const TimeFilterContext = createContext<TimeFilterContextState>(
  initalTimeFilterContextState,
);

export const useTimeFilterContext = () => useContext(TimeFilterContext);
